<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="row">
      <template v-for="(item, index) in language">
        <div class="col-md-6" :key="'Language' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                語言種類
                <span class="en-text">Language</span>
              </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                filterable
                placeholder="請選擇"
                v-model="item.LanguageGuid"
              >
                <el-option
                  v-for="language in languageOptions"
                  :key="language.Guid"
                  :label="language.Name"
                  :value="language.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'LanguageDescription' + index">
          <template
            v-if="item.LanguageGuid === '11111111-1111-1111-1111-111111111111'"
          >
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  語言描述
                  <span class="en-text">Language</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="item.LanguageDescription"
                />
              </div>
            </div>
          </template>
        </div>

        <div class="col-md-6" :key="'Listen' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }"> Listening Skill </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="item.ListenGuid"
              >
                <el-option
                  v-for="degree in degreeOptions"
                  :key="degree.Guid"
                  :label="degree.Name"
                  :value="degree.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'Speak' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }"> Speaking Skill </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="item.SpeakGuid"
              >
                <el-option
                  v-for="degree in degreeOptions"
                  :key="degree.Guid"
                  :label="degree.Name"
                  :value="degree.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'Read' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }"> Reading Skill </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="item.ReadGuid"
              >
                <el-option
                  v-for="degree in degreeOptions"
                  :key="degree.Guid"
                  :label="degree.Name"
                  :value="degree.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'Write' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }"> Writing Skill </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="item.WriteGuid"
              >
                <el-option
                  v-for="degree in degreeOptions"
                  :key="degree.Guid"
                  :label="degree.Name"
                  :value="degree.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'LanguageTest' + index">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                語言檢定
                <span class="en-text">Language Verification</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="200"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="item.LanguageTest"
              />
            </div>
          </div>
        </div>

        <div class="col-md-6" :key="'button' + index">
          <button
            v-if="language.length > 1"
            type="button"
            class="del-btn"
            @click="del(index)"
          >
            {{ $t("BUTTON.RESUME_DELETE") }}
          </button>
        </div>
      </template>
    </div>

    <div class="edit-btn-wrap">
      <!-- 新增 -->
      <button type="button" class="btn-sm add-btn" @click="add">
        {{ $t("BUTTON.RESUME_ADD") }}
      </button>
      <!-- 儲存 -->
      <button type="button" class="put-btn" @click="saveLanguage">
        {{ $t("BUTTON.RESUME_SAVE") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLLanguage",

  data() {
    return {
      language: [],

      languageOptions: [],
      degreeOptions: [],

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 語言能力
    saveLanguage() {
      this.$api.idl
        .putLanguage(this.source, {
          Details: this.language,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "語言能力儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getLanguage();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 語言能力
    getLanguage() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getLanguage(this.source, candidate).then((response) => {
        if (response.status === 200) {
          if (response.data.length === 0) {
            this.language.push({});
          } else {
            this.language = response.data;
          }
        }
        this.updateLoading(false);
      });
    },

    add() {
      this.language.push({});
    },

    del(index) {
      this.language.splice(index, 1);
    },

    async getData() {
      // 取得 語言列表
      const language = await this.$api.language.getLanguage();
      this.languageOptions = language.data.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
      // 取得 程度列表
      const degree = await this.$api.language.getLanguageDegree();
      this.degreeOptions = degree.data.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
      await this.getLanguage();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getData();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin-top: 25px;
  color: #fff;
  margin-right: 10px;
}

.add-btn {
  margin-top: 25px;
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
